import axios from "axios"

const apiKey = process.env.REACT_APP_API_KEY
const cloudApiKey = process.env.REACT_APP_SUMMARY_API_KEY

const BASE_URL = 'https://v3.football.api-sports.io'
const CLOUD_BASE_URL = 'https://europe-west1-brainbet.cloudfunctions.net'

const headers = {
    'Content-Type': 'application/json',
    'x-rapidapi-key': `${apiKey}`,
    'x-rapidapi-host': 'v3.football.api-sports.io'
}

export function searchTeam(name) {
    console.log(`name: ${name}`)
    return axios.get(`${BASE_URL}/teams?search=${name}`, {
        headers: headers
    })
}

export function findUpcomingMatches(teamId) {
    console.log(`upcoming matches : ${teamId}`)
    return axios.get(`${BASE_URL}/fixtures?team=${teamId}&next=3`, {
        headers: headers
    })
}

export function fetchLastFiveMatches(teamId) {
    console.log(`Fetch last five matches: ${teamId}`)
    return axios.get(`${BASE_URL}/fixtures?team=${teamId}&last=5`, {
        headers: headers
    })
}

export function fetchInjuriesAndSuspensions(matchId) {
    console.log(`Fetch injuries and suspensions: ${matchId}`)
    return axios.get(`${BASE_URL}/injuries?fixture=${matchId}`, {
        headers: headers
    })
}

export function fetchOdds(matchId) {
    console.log(`Fetch Odds: ${matchId}`)
    return axios.get(`${BASE_URL}/odds?fixture=${matchId}`, {
        headers: headers
    })
}

export function fetchLineups(matchId) {
    console.log(`Fetch Lineups: ${matchId}`)
    return axios.get(`${BASE_URL}/fixtures/lineups?fixture=${matchId}`, {
        headers: headers
    })
}

export function fetchSummary(homeTeamData, awayTeamData, matchOdds, match, h2h, language) {
    const body = {
        language: language,
        match: {
            competition: match.leagueName,
            matchDate: match.matchDate,
            homeTeam: match.teamHomeName,
            awayTeam: match.teamAwayName
        },
        teamStats: {
            homeTeam: homeTeamData,
            awayTeam: awayTeamData
        },
        bettingMarkets: matchOdds,
        headToHead: h2h,
        userIntent: {}
    }
    return axios.post(`${CLOUD_BASE_URL}/generateFootballBettingSummary`, body, {
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': `${cloudApiKey}`
        }
    })
}

export function getHeadToHead(homeTeam, awayTeam) {
    console.log(`Fetched head to head: ${homeTeam} ${awayTeam}`)

    return axios.get(`${BASE_URL}/fixtures/headtohead?h2h=${homeTeam}-${awayTeam}&last=3`, {
        headers: headers
    })
}
